import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
const bar = 'animate-pulse bg-surface-2';
/**
 * Yuklanayotgan mazmun o'rni. Kelajakdagi mazmunning shaklini takrorlaydi,
 * shuning uchun ma'lumot kelganda sahifa sakramaydi.
 */
export const Skeleton = ({ lines = 1, circle = false, className, ...rest }) => {
    if (circle) {
        return (_jsx("div", { "aria-hidden": true, className: cn(bar, 'size-10 rounded-[var(--radius-pill)]', className), ...rest }));
    }
    if (lines <= 1) {
        return _jsx("div", { "aria-hidden": true, className: cn(bar, 'h-4 rounded-[var(--radius-sm)]', className), ...rest });
    }
    return (_jsx("div", { "aria-hidden": true, className: cn('flex flex-col gap-2', className), ...rest, children: Array.from({ length: lines }, (_, i) => (_jsx("div", { className: cn(bar, 'h-4 rounded-[var(--radius-sm)]', i === lines - 1 ? 'w-2/3' : 'w-full') }, i))) }));
};
//# sourceMappingURL=Skeleton.js.map